const __WEBPACK_NAMESPACE_OBJECT__ = require("workbox-webpack-plugin");;